<template>
	<div class="content">
		<h1>Testing</h1>

		<div class="flex margin-top margin-bottom" style="align-items: center">
			<div>New:</div>
			<div class="small-margin-left small-margin-right">
				<select v-model="create_user.locale_id">
					<option v-for="locale in getLocales" :value="locale.id">
						{{ locale.locale }}
					</option>
				</select>
			</div>
			<div>
				<button class="small" :disabled="saving" v-on:click="createUser">Create</button>
			</div>
			<div class="margin-left margin-right">or load user:</div>
			<div>
				<input
					:disabled="saving"
					type="number"
					placeholder="User ID"
					v-model="user_id"
					v-on:keyup.enter="load"
					style="width: 80px" />
			</div>
			<div class="small-margin-left"></div>
			<button class="small"
				:disabled="saving"
				v-on:click="loadNewest">Newest</button>
		</div>

		<div v-if="user_preview" class="margin-top">
			<Tabs
				class="margin-bottom"
				v-model="tab"
				:tabs="tabs" />

			<!-- Profile -->
			<div v-show="tab == 'overview'">
				<div class="flex margin-top">
					<div class="flex-basis padding-right">
						<!-- {{ user_preview }} -->

						<div class="input-row xs-margin-bottom">
							<div class="label">Full name</div>
							<div>{{ user_preview.full_name }}</div>
						</div>
						<div class="input-row xs-margin-bottom">
							<div class="label">Email</div>
							<div>{{ user_preview.email }}</div>
						</div>
						<div class="input-row xs-margin-bottom">
							<div class="label">Password</div>
							<div>testtest</div>
						</div>
						<div class="input-row xs-margin-bottom">
							<div class="label">Phone no.</div>
							<div>{{ user_preview.phone }}</div>
						</div>
						<div class="input-row xs-margin-bottom">
							<div class="label">Birthday</div>
							<div>{{ user_preview.customer_data.birthday }}</div>
						</div>
						<div class="input-row xs-margin-bottom">
							<div class="label">Registration date</div>
							<div>
								<Format type="date" :time="true" :value="user_preview.created_at.date_time" />
							</div>
						</div>
						<div class="input-row xs-margin-bottom">
							<div class="label">Country</div>
							<div>
								<Flag :countryid="user_preview.locale.country_id" />
							</div>
						</div>
						<div class="input-row xs-margin-bottom">
							<div class="label">Survey completed</div>
							<div>
								{{ survey.completed }}
							</div>
						</div>
						<div class="input-row xs-margin-bottom">
							<div class="label">Survey</div>
							<div>
								{{ { card_survey: 'CardSurvey (Survey 2.0)', old_survey: 'Old survey' }[survey.group] || 'Not started yet (the A/B test picks)' }}
							</div>
						</div>

						<div class="margin-top" v-if="!survey.completed">
							<button
								class="small"
								:disabled="saving"
                v-on:click="autoFillSurvey">Auto-fill survey</button>
							<button
								class="small"
								:disabled="saving"
								v-on:click="autoFillCardSurvey(false)">Auto-fill CardSurvey</button>
							<button
								class="small"
								:disabled="saving"
								v-on:click="autoFillCardSurvey(true)">Auto-fill CardSurvey, skipping optional cards</button>
						</div>
            <div class="margin-top" v-if="survey.completed">
              <button
								class="small bg-red"
								:disabled="saving"
								v-on:click="autoRemoveSurvey">Remove survey data</button>
						</div>

					</div>
					<div class="flex-basis padding-left">

						<div class="margin-bottom">
							<strong>Change registration date</strong>
							<div class="xs-margin-top">
								<input type="number" v-model="hours" style="width: 50px" class="small-margin-right" />
								<button class="small" :disabled="saving" v-on:click="setAgeHours">Make {{ hours }} hours old</button>
							</div>
						</div>
						<div class="xs-margin-bottom">
							<a :href="'/#/customer/' + user_id">Open profile</a>
						</div>
						<div class="xs-margin-bottom">
              <a href="#"
                class="smaller"
                :disabled="saving"
                v-on:click="loginAs()"
                icon="account">Log in as {{ user_preview.full_name }}</a>
						</div>

					</div>
					<div class="flex-basis">
						<div
							v-for="(profile, id) in profile_list"
							v-if="profile.locale_id == user_preview.locale.locale_id"
							class="small-margin-bottom">
							<div class="flex align-itemxs">
								<div class="xs-margin-right">
									<Flag :localeid="profile.locale_id" />
								</div>
								<div class="flex-grow">
									<div>
										<strong>{{ profile.first_name }} {{ profile.last_name }}</strong>
									</div>
									<div>
										{{ profile.note }}
									</div>
									<div v-if="profile.ssn">
										<strong>SSN:</strong>
										{{ profile.ssn }}
									</div>
								</div>
								<div>
									<button
										:disabled="saving"
										v-on:click="setProfile(id)"
										class="small">Set as profile</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Orders -->
			<div v-show="tab == 'orders'">
				<div>

					<!-- List of orders -->
					<div v-for="record in orders" class="small-padding border margin-bottom">
						<Modal
							v-if="record._create_exchange"
							v-on:close="toggle(record, '_create_exchange')">
							<create-exchange-order
								:id="record.order.id"
								:data="record"
								v-on:updated="load(); record._create_exchange = false"
								/>
						</Modal>

						<Modal
							v-if="record._warehouse"
							v-on:close="toggle(record, '_warehouse')">
							<order-warehouse
								:id="record.order.id"
								:data="record"
								:loading="saving"
								v-on:updated="load()"
								/>
						</Modal>

						<div class="flex">
							<div class="flex-grow">
								<OrderLink :id="record.order.id" />
								<!-- <a :href="'/#/order/' + record.order.id">{{ record.order.id }}</a> -->
								<div class="xs-margin-top note">
									{{ record.order.order_type.name }}
								</div>
							</div>
							<div>
								<!-- <button :disabled="true" class="small small-margin-right">Pick</button> -->
								<button v-if="record.order.order_type.identifier !== 'webshop'"
									class="small small-margin-left"
									v-on:click="toggle(record, '_warehouse')">Warehouse</button>
                <button v-if="record.order.order_type.identifier !== 'webshop'"
									class="small small-margin-left"
									v-on:click="toggle(record, '_create_exchange')">Exchange</button>
								<button
									v-if="record.outbound.record"
									:disabled="saving"
									class="small small-margin-left"
									v-on:click="makeChargeable(record.order.id)">Make chargeable</button>
							</div>
						</div>

						<!-- Navigation -->
						<div
							class="margin-top large-margin-bottom">
							<order-navigation
								v-model="record.order._tab"
								:data="record"
								/>
						</div>

						<!-- Products -->
						<div
							v-if="record.order._tab == 'products'"
							style="width: 600px; margin: auto; margin-top: 70px;margin-bottom: 40px;"
							class="large-margin-top">
							<div
								class="text-center"
								v-if="!record.order_lines.length">
								No products added on this order
								<div class="margin-top">
									<div>
										<button
											:disabled="saving"
											class=""
											v-on:click="populate(record.order.id)">Add products</button>
									</div>
								</div>
							</div>
							<table
								v-else>
								<thead>
									<tr>
										<th>SKU</th>
										<th>Qty ordered</th>
										<th>Returned</th>
										<th>Qty total</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="line in record.order_lines">
										<td>{{ line.variant ? line.variant.sku : line.product.sku }}</td>
										<td>{{ line.qty.original }}</td>
										<td>{{ line.qty.returned }}</td>
										<td>{{ line.qty.total }}</td>
									</tr>
								</tbody>
							</table>
						</div>

						<!-- General -->
						<div
							v-if="!record.order._tab"
							style="width: 600px; margin: auto; margin-top: 70px;margin-bottom: 40px; text-align: center;"
							class="margin-top">
							<div
								class="flex">
								<div style="width: 200px">Order date</div>
								<input
									:disabled="saving"
									style="margin-right: 8px"
									v-model="record.order.order_date.date"
									type="date"
									v-on:keyup.enter="updateOrder(record.order)" />
								<input
									:disabled="saving"
									style="margin-right: 8px"
									v-model="record.order.order_date.time"
									type="time"
									step="900"
									v-on:keyup.enter="updateOrder(record.order)" />
								<button
									class="small gray"
									style="margin-right: 8px"
									v-on:click="setHoursOld(record.order, 48)">48h</button>
								<button
									class="small gray"
									style="margin-right: 8px"
									v-on:click="setHoursOld(record.order, 336)">2W</button>
								<button
									class="small gray"
									style="margin-right: 8px"
									v-on:click="setHoursOld(record.order, 720)">1M</button>
								<button
									:disabled="saving"
									class="small"
									v-on:click="updateOrder(record.order)">Save</button>
							</div>
						</div>

						<!-- Outbound & DLV -->
						<div
							v-if="record.order._tab == 'outbound'"
							class="">

							<div style="width: 400px; margin: auto; margin-top: 70px; margin-bottom:  40px; text-align: center">
                <div
                  v-if="record.order.order_type.id == 4"
                  class="small-margin-bottom">
                  <button
                    style="width: 330px;"
                    :disabled="saving"
                    class=""
                    v-on:click="processExchange(record.order.id)">Process Exchange</button>
                </div>

								<div>
									<button
										style="width: 330px;"
										:disabled="saving || isPushedToWarehouse(record)"
										class=""
										v-on:click="generateOutbound(record.order.id)">Push outbound to warehouse</button>
								</div>

								<div
									class="small-margin-top">
									<button
										style="width: 330px;"
										class=""
										:disabled="saving || isReleasedFromWarehouse(record)"
										v-on:click="releaseAndShip(record.order)">Warehouse: Release &amp; Ship</button>
								</div>

                <div class="text-center small-margin-top">Recalculate:</div>
                <div class="flex small-margin-top" style="justify-content: center">
                  <button
                    v-on:click="recalculate(record.order, 'subscription-cost')"
                    style="width: 100px">Sub.</button>
                  <button
                    v-on:click="recalculate(record.order, 'discount')"
                    style="width: 100px" class="small-margin-left small-margin-right">Disc.</button>
                  <button
                    v-on:click="recalculate(record.order, 'loyalty')"
                    style="width: 100px">Loyalty</button>
                </div>

								<div class="small-margin-top">
									<button
										style="width: 330px;"
										class=""
										:disabled="saving || isDlvChecked(record)"
										v-on:click="checkDlv(record.order)">Check DLV from warehouse</button>
								</div>

								<div class="small-margin-top">
									<button
										style="width: 330px;"
										class=""
										:disabled="saving || hasTracking(record)"
										v-on:click="checkTracking(record.order)">Check tracking from warehouse</button>
								</div>
							</div>

						</div>

						<!-- After shipping -->
						<div
							v-if="record.order._tab == 'shipping'"
							class="">

							<div style="width: 600px; margin: auto; margin-top: 70px; margin-bottom:  40px; text-align: center">
								<manage-shipping
									:id="record.order.id"
									:data="record"
									v-on:updated="load(); record._create_shipping = false"
									/>
							</div>
						</div>

						<!-- Split payment -->
						<div
							v-if="record.order._tab == 'payment'"
							class="">
							<div style="width: 600px; margin: auto; margin-top: 70px; margin-bottom:  40px; text-align: center">
								<h3>Split payment</h3>
								<split-payment
									:id="record.order.id"
									:data="record"
									v-on:updated="load" />
								<h3>Links</h3>
								<a :href="record.payment_link">Go to payment link</a>
							</div>
						</div>

						<!-- Return order -->
						<div
							v-if="record.order._tab == 'return'">
							<div style="width: 400px; margin: auto; margin-top: 70px; margin-bottom:  40px; text-align: center">

								<button
									class=""
									:disabled="saving"
									v-on:click="toggle(record, '_warehouse')">Manage returned products</button>
								<button
									class="small-margin-top"
									:disabled="saving"
									v-on:click="checkReturn(record.order)">Check return from warehouse</button>
								<div
									class="margin-top"
									v-if="record.return.record">

									<div class="input-row xs-margin-bottom">
										<div class="label">Sync. at</div>
										<div><Format type="date" :time="true" :value="record.return.record.wp_sync_at" /></div>
									</div>
									<div class="input-row xs-margin-bottom">
										<div class="label">Finalized at</div>
										<div><Format type="date" :time="true" :value="record.return.record.finalized_at" /></div>
									</div>

									<div class="small-margin-top">
										<button
											:disabled="saving"
											v-if="record.return.record.processed_at && !record.return.record.wp_sync_at"
											class="small"
											v-on:click="synchronize(record.order.id)">Synchronize</button>
										<button
											:disabled="saving"
											v-if="record.return.record.wp_sync_at && !record.return.record.finalized_at"
											class="small"
											v-on:click="finalize(record.order.id)">Finalize</button>
									</div>

								</div>
							</div>

						</div><!-- End of tab -->

					</div>

				</div>

				<div class="margin-top text-center"
					style="text-align: center; padding: 30px; border: 2px dashed #ddd">
					<div class="">
						<!-- Create order -->
						<button
							:disabled="saving"
							class="gray margin-right"
							v-on:click="createOrder('styling-fee')">+ styling fee</button>
						<button
							:disabled="saving"
							class="gray margin-right"
							v-on:click="createOrder('styling')">+ styling order</button>
            <button
							:disabled="saving"
							class="gray"
							v-on:click="createOrder('webshop')">+ webshop order</button>
					</div>
				</div>

			</div>

			<!-- Shipping -->
			<div v-show="tab == 'shipping'">
				<CustomerShippingEditor
					:id="user_id"
					:autoload="true" />
			</div>

			<!-- Payment methods -->
			<div v-show="tab == 'payment'">
				<!-- Create payment methods -->
				<div class="flex margin-top">
					<div class="margin-right">
						<select :disabled="saving" v-model="create_payment.id">
							<option value="visa">VISA</option>
							<option value="declined_card">VISA (which will deline)</option>
							<option value="fraudulent_card">VISA (fraudulent, create dispute)</option>
							<option value="require_sca_once">VISA (w/3DSecure)</option>
							<!-- <option value="require_sca_once_declined" disabled="disabled">VISA (w/3DSecure, will decline)</option> -->
							<option value="sepa_direct_debit.nl.success">SEPA Dutch - Instant success</option>
							<option value="sepa_direct_debit.nl.fail">SEPA Dutch - Instant failure</option>
							<option value="sepa_direct_debit.nl.asynchronous.success">SEPA Dutch - Async. success after 3 mins</option>
							<option value="sepa_direct_debit.nl.asynchronous.fail">SEPA Dutch - Async. failure after 3 mins</option>
						</select>
						<button v-on:click="addPaymentMethod" :disabled="saving" class="small small-margin-left">Add payment method</button>
					</div>
					<div>

					</div>
				</div>

				<!-- List of payment methods -->
				<CustomerPaymentMethods :autoload="true" ref="payment_methods" :id="user_id" />

				<div class="padding-top border-top margin-top">
					<a target="_blank" href="https://stripe.com/docs/testing">Find testing cards</a>
				</div>
			</div>

			<!-- Subscription -->
			<div v-show="tab == 'subscription'" mode="testing">
				<Subscription :customer="user_id" />
			</div>
		</div>

	</div>
</template>

<script>
import axios from 'axios/index'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import CustomerPaymentMethods from '@/components/CustomerPaymentMethods.vue'
import CustomerShippingEditor from '@/components/CustomerShippingEditor.vue'
import splitPayment from '@/components/testing/OrderSplitPayment.vue'
import createExchangeOrder from '@/components/testing/OrderCreateExchange.vue'
import manageShipping from '@/components/testing/OrderManageShipping.vue'
import orderWarehouse from '@/components/testing/OrderWarehouse.vue'
import orderNavigation from '@/components/testing/OrderNavigation.vue'

export default {
  computed: {
    ...mapGetters([
      'getLocales'
    ])
  },
  components: {
    CustomerPaymentMethods,
    CustomerShippingEditor,
    splitPayment,
    createExchangeOrder,
    manageShipping,
    orderWarehouse,
    orderNavigation
  },
  data: () => ({
    tabs: {
      overview: {
        name: 'Profile'
      },
      orders: {
        name: 'Orders'
      },
      payment: {
        name: 'Payment methods'
      },
      shipping: {
        name: 'Shipping'
      },
      subscription: {
        name: 'Subscription'
      }
    },
    tab: 'overview',
    saving: false,
    loading: false,
    user_preview: false,
    show_returns: false,
    create_user: {
      locale_id: 1
    },
    create_payment: {
      id: 'visa'
    },
    user_id: false,
    hours: 48,
    survey: {},
    orders: [],
    return_lines: {},
    profile_list: []
  }),
  methods: {
    toggle (record, key) {
      Vue.set(record, key, !record[key])
    },
    loadNewest () {
      Vue.$api.get('/testing/user/latest', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => {
          this.user_id = data.id
          this.load()
        }
      })
    },
    /**
			 * [toggleReturn description]
			 * @param  {[type]} id [description]
			 * @return {[type]}    [description]
			 */
    toggleReturn (id) {
      Vue.set(this, 'return_lines', {})

      this.show_returns = this.show_returns === id ? false : id
    },

    /**
			 * [generateReturn description]
			 * @return {[type]} [description]
			 */
    finalize (id) {
      Vue.$api.post('/return-order/' + id + '/finalize', {
        force: true
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },

    setHoursOld (order, h) {
      const date = Vue.$create.dateTime(order.order_date.date_time)

      date.addHours(-h)

      Vue.set(
        order.order_date,
        'date',
        date.format('Y-m-d')
      )

      Vue.set(
        order.order_date,
        'time',
        date.format('H:i')
      )
    },
    updateOrder (order) {
      Vue.$api.patch('/testing/order/' + order.id, {
        order: order
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },

    /**
			 * [generateReturn description]
			 * @return {[type]} [description]
			 */
    synchronize (id) {
      Vue.$api.post('/return-order/' + id + '/synchronize', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },

    /**
			 * [generateReturn description]
			 * @return {[type]} [description]
			 */
    processFile (filename) {
      Vue.$api.post('/return-order-file/' + filename + '/process', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },

    /**
			 * [generateReturn description]
			 * @return {[type]} [description]
			 */
    generateOutbound (id) {
      Vue.$api.post('/testing/order/' + id + '/outbound', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    processExchange (id) {
      Vue.$api.post('/testing/order/' + id + '/exchange', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },

    /**
			 * [generateReturn description]
			 * @return {[type]} [description]
			 */
    generateReturn () {
      Vue.$api.post('/testing/order/' + this.show_returns + '/return-file', {
        order_line_ids: this.return_lines
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },

    /**
			 * [autoFillSurvey description]
			 * @return {[type]} [description]
			 */
    autoFillSurvey () {
      Vue.$api.post('/testing/user/' + this.user_id + '/survey', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    autoFillCardSurvey (skipOptional) {
      Vue.$api.post('/testing/user/' + this.user_id + '/card-survey', { skip_optional: skipOptional }, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    autoRemoveSurvey () {
      Vue.$api.delete('/testing/user/' + this.user_id + '/survey', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },

    /**
			 * [autoFillSurvey description]
			 * @return {[type]} [description]
			 */
    setProfile (id) {
      Vue.$api.patch('/testing/user/' + this.user_id + '/profile', {
        profile: id
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },

    /**
			 * [populate description]
			 * @param  {[type]} id [description]
			 * @return {[type]}    [description]
			 */
    makeChargeable (id) {
      Vue.$api.post('/testing/order/' + id + '/chargeable', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.parseUser(data)
      })
    },

    /**
			 * [populate description]
			 * @param  {[type]} id [description]
			 * @return {[type]}    [description]
			 */
    populate (id) {
      Vue.$api.post('/testing/order/' + id + '/populate', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.parseUser(data)
      })
    },

    /**
			 * [addPaymentMethod description]
			 */
    addPaymentMethod () {
      Vue.$api.post('/testing/user/' + this.user_id + '/payment-method', this.create_payment, {
        loader: toggle => this.saving = toggle,
        callback: data => this.parseUser(data)
      })
    },

    /**
			 * [createOrder description]
			 * @param  {[type]} type [description]
			 * @return {[type]}      [description]
			 */
    createOrder (type) {
      Vue.$api.post('/testing/user/' + this.user_id + '/order', {
        type: type
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => this.parseUser(data)
      })
    },

    /**
			 * [load description]
			 * @return {[type]} [description]
			 */
    load () {
      Vue.$api.get('/testing/user/' + this.user_id, {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.parseUser(data)
      })
    },

    /**
			 * [setAgeHours description]
			 * @param {[type]} hours [description]
			 */
    setAgeHours () {
      Vue.$api.patch('/testing/user/' + this.user_id + '/create-date', {
        hours: this.hours
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => this.parseUser(data)
      })
    },

    /**
			 * [createUser description]
			 * @return {[type]} [description]
			 */
    createUser () {
      Vue.$api.post('/testing/user', this.create_user, {
        loader: toggle => this.saving = toggle,
        callback: data => this.parseUser(data)
      })
    },
    loginAs () {
      Vue.api.post('/customer/' + this.user_id + '/login-as', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.onLoginAs(data)
      })
    },
    onLoginAs (data) {
      window.open(data.redirect_to, '_blank')
    },
    /**
			 * [parseUser description]
			 * @param  {[type]} data [description]
			 * @return {[type]}      [description]
			 */
    parseUser (data) {
      // Make sure everything properly resets, when the
      // user ID might have changed
      this.user_preview = false
      this.user_id = false
      this.orders = false
      this.survey = false
      this.profile_list = false

      setTimeout(() => {
        this.user_preview = data.customer
        this.user_id = data.customer.id
        this.orders = data.orders
        this.survey = data.survey
        this.profile_list = data.profile_list
      }, 100)
    },
    releaseAndShip (order) {
      Vue.$api.post(
        '/testing/order/' + order.id + '/warehouse/shipped',
        {},
        {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: () => this.load()
        })
    },
    recalculate(order, section) {
      Vue.$api.post(
        '/order/' + order.id + '/calculate/' + section,
        {},
        {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: () => this.load()
        })
    },
    checkDlv (order) {
      Vue.$api.post(
        '/testing/order/' + order.id + '/check-dlv',
        {},
        {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: () => this.load()
        })
    },
    checkReturn (order) {
      Vue.$api.post(
        '/testing/order/' + order.id + '/check-return',
        {},
        {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: () => this.load()
        })
    },
    checkTracking (order) {
      Vue.$api.post(
        '/testing/order/' + order.id + '/check-tracking',
        {},
        {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: () => this.load()
        })
    },
    isPushedToWarehouse (record) {
      return record.outbound.record !== null && record.outbound.record.push_to_warehouse_at !== null
    },
    isReleasedFromWarehouse (record) {
      return record.warehouse.sales_order !== null && record.warehouse.sales_order.shipped_at !== null
    },
    isDlvChecked (record) {
      return record.dlv !== null && record.dlv.processed_at !== null
    },
    hasTracking (record) {
      return record.shipment.trackings.length > 0
    }
  },
  created () {
    if (this.$route.query.uid) {
	  this.user_id = this.$route.query.uid
	  this.load()
    }
  }
}
</script>
